module.exports = __webpack_public_path__ + "static/media/file3.7b87dae8.jpg";